/**
 * UTF-16 Big Endian Encoding.
 *
 * @public
 */
export const UTF_16_BE = 'utf-16be'
